import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { notification_filterActions } from "../actions";
import { notificationFilterConstants } from "../constants";

/**
 * Hook to manage notification filter state and initialization
 * @returns {Object} Empty object (could be extended with filter state if needed)
 */
function useNotificationFilter() {
    const dispatch = useDispatch();
    
    useEffect(() => {
        // Reset filter selection on mount
        dispatch({ 
            type: notificationFilterConstants.SELECT_NOTIFICATION_FILTER, 
            payload: null 
        });

        // Handle successful filter data fetch
        const handleFilterFetchSuccess = (response) => {
            const { data: filterData, organizations } = response.data.data;

            dispatch({ 
                type: notificationFilterConstants.SET_UNSELECTED_ORGANIZATION_IDS, 
                payload: filterData.unselected_organization_ids 
            });

            dispatch({ 
                type: notificationFilterConstants.SET_UNSELECTED_WORKSPACE_IDS, 
                payload: filterData.unselected_workspace_ids 
            });

            dispatch({ 
                type: notificationFilterConstants.SET_NOTIFICATION_FILTER, 
                payload: filterData 
            });
            
            dispatch({ 
                type: notificationFilterConstants.GET_ORGANIZATION_FILTERS, 
                payload: organizations 
            });
        }

        // Handle filter fetch errors
        const handleFilterFetchError = (error) => {
            console.error('Failed to fetch notification filters:', error);
        }

        // Fetch notification filters
        dispatch(notification_filterActions.getNotificationFilter({
            onSuccess: handleFilterFetchSuccess,
            onError: handleFilterFetchError
        }));

        // Cleanup: reset filter selection on unmount
        return () => {
            dispatch({ 
                type: notificationFilterConstants.SELECT_NOTIFICATION_FILTER, 
                payload: null 
            });
        }
    }, [dispatch]);

    return {};
}

export default useNotificationFilter;